import { Session } from './session.reducer'

/**
 * Gets a title of the session based on the accounts loaded
 * e.g. 'No Accounts', 'Account 51212', 'Account 51212(+5)
 */
export function getSessionTitle(session: Session | undefined | null): string {
  if (!session) return 'Null Session' //for convenience of nullability, but this should never happen

  const numAccts = session.loadedAccountIds.length
  if (numAccts === 0) return `No Accounts`
  const firstAcct = session.loadedAccountIds[0]
  if (numAccts === 1) return `Account ${firstAcct}`

  return `Account ${firstAcct} (+${numAccts - 1})`
}
